import { appFeatureGroups, appFeatureList, appStores } from "../siteContent";
import { NavLink } from "./NavLink";

const metrics = [
  { value: appFeatureGroups.length, label: "feature areas" },
  { value: `${appFeatureList.length}+`, label: "connected tools" },
  { value: "2", label: "mobile platforms" },
  { value: "Online + offline", label: "study continuity" }
];

export function AppFeatureShowcase({ navigate, mode = "home" }) {
  const isAppPage = mode === "app";

  return (
    <section
      className={`app-feature-showcase is-${mode}`}
      aria-labelledby={`app-feature-showcase-title-${mode}`}
    >
      <header className="app-feature-showcase-header">
        <div>
          <span className="section-eyebrow">Complete app experience</span>
          <h2 id={`app-feature-showcase-title-${mode}`}>
            Everything an aspirant needs, connected in one study flow
          </h2>
        </div>
        <p>
          Aspirant CSS brings subject learning, written-paper preparation,
          objective practice, revision and saved progress together without
          making every study action depend on a live connection.
        </p>
      </header>

      {!isAppPage ? (
        <div className="app-feature-urdu-band" lang="ur-Latn" dir="ltr">
          <span className="app-feature-urdu-mark" aria-hidden="true">♡</span>
          <div>
            <span className="app-feature-note-label">Meri Jaan ❤️</span>
            <strong>CSS mushkil zaroor hai… lekin har cheez mushkil banani zaroori nahi. 😄</strong>
            <p>10 PDFs, 6 WhatsApp groups aur “yeh topic kahan se karun?” wali tension ko thora side par rakhein.</p>
            <p>Lectures, MCQs, notes aur progress sab <b>“Aspirant CSS App”</b> mein ek jagah hain. App download karein—aur tayari ko thora smart, thora simple bana dein. ❤️</p>
            <div className="app-feature-urdu-actions" aria-label="Download Aspirant CSS">
              <a href={appStores.android.url} target="_blank" rel="noreferrer">
                Continue on Android <span aria-hidden="true">↗</span>
              </a>
              <a href={appStores.ios.url} target="_blank" rel="noreferrer">
                Continue on iPhone <span aria-hidden="true">↗</span>
              </a>
            </div>
          </div>
        </div>
      ) : null}

      <div className="app-feature-metrics" aria-label="Aspirant app feature summary">
        {metrics.map((metric) => (
          <div key={metric.label}>
            <strong>{metric.value}</strong>
            <span>{metric.label}</span>
          </div>
        ))}
      </div>

      <div className="app-feature-groups">
        {appFeatureGroups.map((group, index) => (
          <details className={`app-feature-group tone-${(index % 5) + 1}`} key={group.id}>
            <summary>
              <span className="app-feature-group-mark" aria-hidden="true">{group.shortLabel.slice(0, 2)}</span>
              <span className="app-feature-group-copy">
                <small>{group.shortLabel} · {group.features.length} features</small>
                <strong>{group.title}</strong>
                <span>{group.summary}</span>
              </span>
              <span className="app-feature-group-toggle" aria-hidden="true">+</span>
            </summary>
            <ul>
              {group.features.map((feature) => (
                <li key={feature.title}>
                  <span className="app-feature-check" aria-hidden="true">✓</span>
                  <span>
                    <strong>{feature.title}</strong>
                    <span>{feature.text}</span>
                  </span>
                </li>
              ))}
            </ul>
          </details>
        ))}
      </div>

      <footer className="app-feature-showcase-footer">
        <div>
          <span className="section-eyebrow">See the complete guide</span>
          <strong>Compare every feature before you download.</strong>
        </div>
        <div className="app-feature-showcase-actions">
          {!isAppPage ? (
            <NavLink
              to="/blog/aspirant-css-app-complete-features"
              className="button app-feature-guide-link"
              onNavigate={navigate}
            >
              Read all app features <span aria-hidden="true">→</span>
            </NavLink>
          ) : null}
          <a className="button app-feature-store-link is-android" href={appStores.android.url} target="_blank" rel="noreferrer">
            Google Play <span aria-hidden="true">↗</span>
          </a>
          <a className="button app-feature-store-link is-ios" href={appStores.ios.url} target="_blank" rel="noreferrer">
            App Store <span aria-hidden="true">↗</span>
          </a>
        </div>
      </footer>
    </section>
  );
}
